import React from 'react';
import TextCell from '@components/Table/cells/TextCell';
import type {TdProps} from '../core/Td';

type UPCCellProps = {
	upc: string;
} & TdProps;

const UPCCell = ({upc, ...rest}: UPCCellProps) => {
	return <TextCell value={upc} {...rest} />;
};

export default UPCCell;
